import script from "./task-templates-configuration-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./task-templates-configuration-modal.vue?vue&type=script&setup=true&lang=ts"

import "./task-templates-configuration-modal.vue?vue&type=style&index=0&id=2021ed9f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2021ed9f"]])

export default __exports__